export default __webpack_public_path__ + "static/media/art-pro-slt-poster-3.c2ef02e6.jpg";